

























































































import { computed, defineComponent, ref } from '@vue/composition-api';
import { Feature, MultiPolygon, Polygon } from 'geojson';
import { useCreateField } from '@/store/modules/fields';
import { Area, ContactPoint, Field } from '@/store/types';
import AreaDrawEditor from './Area/AreaDrawEditor.vue';
import AreaDrawReview from './Area/AreaDrawReview.vue';
import FieldAddress from './FieldAddress/FieldAddress.vue';
import FieldContact from './FieldContact/FieldContact.vue';
import FieldCreateForm from './FieldCreate/FieldCreateForm.vue';

enum FieldCreateStepEnum {
	AREA = 1,
	FORM,
	REVIEW,
}

export default defineComponent({
	components: { FieldCreateForm, AreaDrawEditor, AreaDrawReview, FieldAddress, FieldContact },
	setup(props, { root }) {
		const step = ref<number>(FieldCreateStepEnum.AREA);
		const field = ref<Partial<Field>>({});
		const area = ref<Feature<MultiPolygon>>();
		const areaDraws = ref<Feature<Polygon>[]>([]);
		const { createField, clearError, isLoading, hasError } = useCreateField(root.$store);

		const isValidObject = (obj: { [key: string]: string } = {}): boolean => Object.values(obj).join().length > 0;

		const validContactPoints = computed<ContactPoint[]>(() => field.value.contactPoints?.filter(isValidObject) ?? []);

		const handleFieldForm = (value: Partial<Field>) => {
			field.value = value;
			step.value = FieldCreateStepEnum.REVIEW;
		};

		const handleArea = (finalizedArea: Feature<MultiPolygon>) => {
			area.value = finalizedArea;
			step.value = FieldCreateStepEnum.FORM;
		};

		const handleSubmit = () => {
			clearError();

			createField({
				groupId: field.value.meta?.groupId ?? '',
				name: field.value.name,
				producerName: field.value.producerName,
				address: field.value.address,
				contactPoints: validContactPoints.value,
				areas: area.value
					? [
							{
								...area.value,
								properties: { ...area.value.properties, drawn: true },
							} as Omit<Area, 'id'>,
					  ]
					: [],
			});
		};

		const navigateToFieldsView = () => root.$router.push('/fields');

		return {
			FieldCreateStepEnum,
			step,
			field,
			area,
			areaDraws,
			validContactPoints,
			isLoading,
			hasError,
			clearError,
			isValidObject,
			handleFieldForm,
			handleArea,
			handleSubmit,
			navigateToFieldsView,
		};
	},
});
